import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import styled from 'styled-components';
import { Button as DefaultButton } from '../../styled-components';
import { localizeAxis as localize } from '../../util/localizeUtils';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    background: '#F0F0F0',
    padding: '1rem'
  },
  overlay: {
    zIndex: 100001
  }
};

const Button = styled(DefaultButton)`
  line-height: inherit;
  margin: 0 .5rem;
`;

class ConfirmCloseDialog extends Component {
  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        style={customStyles}
        onRequestClose={this.props.onCancelClick}
        contentLabel="ConfirmClose"
      >
        <div>{localize('confirmDeleteOrderText')}</div>
        <div style={{ textAlign: 'right' }}>
          <Button onClick={this.props.onOkClick}>{localize('okButton')}</Button>
          <Button onClick={this.props.onCancelClick}>{localize('cancelButton')}</Button>
        </div>
      </Modal>
    );
  }
}

ConfirmCloseDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  onOkClick: PropTypes.func.isRequired
};

export default ConfirmCloseDialog;



// WEBPACK FOOTER //
// ./app/components/OrderForm/ConfirmCloseDialog.js